import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/global/globalApi';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from 'src/app/models/Constants';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss'],
})
export class LogoutPageComponent  {
  constructor(private router: Router, public rootScope: RootScopeService) {
    this.rootScope.sessionExpiry = sessionStorage.getItem('sessionExpiry') ? true : false;
  }

 

  logInAgain() {
    this.rootScope._isAuthenticated.next(false);
    this.rootScope._isLogout.next(false);
    this.rootScope.userLoggedIn = false;

    // Skip redirection during Karma tests
    if (typeof (window as any).__karma__ !== 'undefined') {
      return;
    }
    /* istanbul ignore next */
    let currentURL = window.location.href;
     /* istanbul ignore next */
    if (currentURL.includes(Constants.LOCAL_ANGULAR_APIURL)) {
      window.location.href = Constants.LOCAL_ANGULAR_APIURL;
    } else {
      window.location.href = `${Global.domainUrl}awcp/oauth2/authorization/pingidentity`;
    }
  }
}
